/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWebAuthnCredentialInfo
 */
export interface OutputWebAuthnCredentialInfo {
    /**
     * 
     * @type {string}
     * @memberof OutputWebAuthnCredentialInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputWebAuthnCredentialInfo
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputWebAuthnCredentialInfo
     */
    lastUsedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputWebAuthnCredentialInfo
     */
    name?: string;
}

/**
 * Check if a given object implements the OutputWebAuthnCredentialInfo interface.
 */
export function instanceOfOutputWebAuthnCredentialInfo(value: object): boolean {
    return true;
}

export function OutputWebAuthnCredentialInfoFromJSON(json: any): OutputWebAuthnCredentialInfo {
    return OutputWebAuthnCredentialInfoFromJSONTyped(json, false);
}

export function OutputWebAuthnCredentialInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWebAuthnCredentialInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'id': json['id'] == null ? undefined : json['id'],
        'lastUsedAt': json['lastUsedAt'] == null ? undefined : json['lastUsedAt'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OutputWebAuthnCredentialInfoToJSON(value?: OutputWebAuthnCredentialInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'id': value['id'],
        'lastUsedAt': value['lastUsedAt'],
        'name': value['name'],
    };
}

